import { JSX, CSSProperties } from 'react'
import { NavLink } from 'react-router'

import { chakra, For, Flex, Image, HStack, VStack, Icon, Text } from '@chakra-ui/react'

import { RxExit, RxDashboard } from 'react-icons/rx'

import logo from '/public/images/logo.png'
import navigate_i_x_001 from '/public/images/ui/navigate/i.x.001@2x.png'




export type TOption = {
	name: string
	path: string

	icon: JSX.Element

}

export type TOptions = TOption[]

export const display = { base: 'none', xl: 'block' }

export const justify = { base: 'center', xl: 'start' }

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Active
(props: TOption): JSX.Element
{
	let I = chakra('i')

	return (
		<>
			<HStack
				p="2"
				gap="4"
				rounded="md"
				bg="bg.info"
				justify={justify}
				_hover={{ bg: 'bg.info' }}
			>
				<Icon boxSize="4" color="blue.solid">{props.icon}</Icon>

				<Text fontSize="md" fontWeight="bold" color="blue.solid" whiteSpace="nowrap" display={display}>{props.name}</Text>

			</HStack>

			<I
				w="1"
				h="92%"
				position="absolute"
				right="calc(0px - {sizes.3})"
				top="4%"
				bgColor="blue.border"
				rounded="xl"
			/>

		</>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Inactive
(props: TOption): JSX.Element
{
	return (
		<HStack
			p="2"
			gap="4"
			rounded="md"
			bg="transparent"
			justify={justify}
			_hover={{ bg: 'bg.info' }}
		>
			<Icon boxSize="4" color="fg.subtle">{props.icon}</Icon>

			<Text fontSize="md" color="fg.muted" whiteSpace="nowrap" display={display}>{props.name}</Text>
		</HStack>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Option
(props: TOption): JSX.Element
{
	let style: CSSProperties = {
		width   : 'var(--chakra-sizes-full)',
		position: 'relative',

	}

	return (
		<NavLink to={`/${props.path}`} style={style}>
			{item => item.isActive ? <Active {...props} /> : <Inactive {...props} />}

		</NavLink>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Options
(
	props: {
		value: TOptions

	},

)
:	JSX.Element
{
	return (
		<VStack mt="4" mb="auto" gap="4" alignItems="flex-start">
			<Option icon={<RxDashboard />} name="仪表盘" path="/" />

			<For each={props.value}>
				{v => <Option key={v.path} icon={v.icon} name={v.name} path={v.path} />}

			</For>

		</VStack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		children: JSX.Element
	},

)
:	JSX.Element
{
	return (
		<Flex
			w="full"
			minH="vh"
			p={{ base: 2, xl: 4 }}
			bg="white"
			flexDirection="column"
			justifyContent="space-between"
			shadow="sm"
		>
			<Image boxSizing="content-box" boxSize="8" src={logo} />

			{props.children}

			<Image src={navigate_i_x_001} display={display} />

			<HStack gap="2" mt="12" cursor="pointer" justify={justify}>
				<Icon color="fg.subtle" boxSize="4">
					<RxExit />
				</Icon>

				<Text color="fg.subtle" fontSize="sm" display={display}>注销</Text>
			</HStack>
		</Flex>

	)

}
